import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <line
            stroke="currentColor"
            strokeLinecap="round"
            x1="1.5"
            x2="14.5"
            y1="13.5"
            y2="13.5"
        />
        <path
            d="M9.5 3L10.2929 2.20711C10.6834 1.81658 11.3166 1.81658 11.7071 2.20711L12.7929 3.29289C13.1834 3.68342 13.1834 4.31658 12.7929 4.70711L12 5.5M9.5 3L3.5 9V11.5H6L12 5.5M9.5 3L12 5.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Icon;
